import { styled } from '@mui/material/styles';
import { Chip } from '@mui/material';

export const StyledChip = styled(Chip)(() => ({
  '&.MuiChip-root': {
    height: '28px',
  },
}));
